// src/store/slices/adminAuthSlice.ts
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemUser } from '@/models/SystemUser';
import { fetchAdminUserMe } from '@/services/authService';

interface AdminAuthState {
  isAuthenticated: boolean;
  user: SystemUser | null;
}

const initialState: AdminAuthState = {
  isAuthenticated: false,
  user: null
};

export const fetchAdminUserDetails = createAsyncThunk(
  'adminAuth/fetchAdminUserDetails',
  async (_, { rejectWithValue }) => {
    try {
      const user = await fetchAdminUserMe();
      return user;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    setCredentials: (
      state: AdminAuthState,
      action: PayloadAction<{ user: SystemUser }>
    ) => {
      const { user } = action.payload;
      state.isAuthenticated = true;
      state.user = user;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminUserDetails.fulfilled, (state, action: PayloadAction<SystemUser>) => {
        state.isAuthenticated = true;
        state.user = action.payload;
      })
      .addCase(fetchAdminUserDetails.rejected, (state) => {
        state.isAuthenticated = false;
        state.user = null;
      });
  },
});

export const { setCredentials, logout } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
export type { AdminAuthState };